import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { selectOwnershipStructure } from '~/store/identification-form/selectors.ts';
import { OwnerType } from '~/modules/identification/forms/OwnershipStructure/types.ts';

export const useBeneficiaryOwners = () => {
  const { owners } = useSelector(selectOwnershipStructure) || {};

  const beneficiaryOwners = useMemo(
    () => (owners || []).filter((owner) => owner.isBeneficiary),
    [owners]
  );

  const individualOwners = useMemo(
    () => (owners || []).filter((owner) => owner.type === OwnerType.INDIVIDUAL),
    [owners]
  );

  return { beneficiaryOwners, individualOwners };
};
